// ActionButtons.js - Navigation buttons
import React from 'react';
import { Box, Fab, Tooltip, ToggleButtonGroup, ToggleButton, Paper, useTheme } from '@mui/material';
import TodayIcon from '@mui/icons-material/Today';
import ViewDayIcon from '@mui/icons-material/ViewDay';
import ViewWeekIcon from '@mui/icons-material/ViewWeek';
import ViewModuleIcon from '@mui/icons-material/ViewModule';
import EditIcon from '@mui/icons-material/Edit';
import CloseIcon from '@mui/icons-material/Close';
import { useGanttDnd } from '../../context/GanttDndContext';

const ActionButtons = ({ onJumpToToday, onJumpToBaseDate, viewMode, onViewModeChange, enableDnd = true }) => {
  const theme = useTheme();
  const { isEditMode, toggleEditMode } = useGanttDnd();

  return (
    <Box
      sx={{
        position: 'fixed',
        bottom: 20,
        right: 20,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        zIndex: 105,
        gap: 3
      }}
    >
      {/* View Mode Selector */}
      {onViewModeChange && (
        <Paper elevation={8} sx={{ borderRadius: 2, width: "fit-content" }}>
          <ToggleButtonGroup
            value={viewMode}
            exclusive
            onChange={(e, newMode) => newMode && onViewModeChange(newMode)}
            orientation="vertical"
            size="small"
            sx={{
              '& .MuiToggleButton-root': {
                py: 1,
                px: 1.5,
                borderRadius: 2,
              }
            }}
          >
            <Tooltip title="Day View" placement="left">
              <ToggleButton value="day" aria-label="day view">
                <ViewDayIcon fontSize="small" />
              </ToggleButton>
            </Tooltip>
            <Tooltip title="Week View" placement="left">
              <ToggleButton value="week" aria-label="week view">
                <ViewWeekIcon fontSize="small" />
              </ToggleButton>
            </Tooltip>
            <Tooltip title="Month View" placement="left">
              <ToggleButton value="month" aria-label="month view">
                <ViewModuleIcon fontSize="small" />
              </ToggleButton>
            </Tooltip>
          </ToggleButtonGroup>
        </Paper>
      )}

      {/* Edit Mode Toggle Button */}
      {enableDnd && (
        <Tooltip title={isEditMode ? "Exit Edit Mode" : "Enable Drag & Drop"} placement="left">
          <Fab
            color={isEditMode ? "error" : "default"}
            size="medium"
            onClick={toggleEditMode}
            sx={{
              zIndex: 105,
              boxShadow: theme.shadows[8],
              '&:hover': {
                transform: 'scale(1.05)',
                transition: 'transform 0.2s ease-in-out'
              }
            }}
          >
            {isEditMode ? <CloseIcon /> : <EditIcon />}
          </Fab>
        </Tooltip>
      )}

      {/* Jump to Today Button */}
      <Tooltip title="Jump to Today" placement="left">
        <Fab
          color="primary"
          size="medium"
          onClick={onJumpToToday}
          sx={{
            zIndex: 105,
            boxShadow: theme.shadows[8],
            '&:hover': {
              transform: 'scale(1.05)',
              transition: 'transform 0.2s ease-in-out'
            }
          }}
        >
          <TodayIcon />
        </Fab>
      </Tooltip>
    </Box>
  );
};

export default ActionButtons;
